// Theme custom js

// const { __esModule } = require("./dist/dom/polyfill");

document.addEventListener("DOMContentLoaded", function(event) 
{
  console.log('Loaded... theme.js');

  var msg = {
    fileTooLarge : 'File too large!',
  }
  var d = document;

  const alert_delay = 6000; // 
  const max_uploads = 3;
  const max_size = 10000000;
  const fname = 'cv-multifile[]';

  // Hack for adding "stuck" class for active stickies
  if (typeof IntersectionObserver !== 'undefined') {
    var stickyObserver = new IntersectionObserver(
      ([e]) => {
        return e.target.toggleAttribute('stuck', e.intersectionRatio < 1);
      },
      { threshold: [1] }
    );
    stickyObserver.observe(d.querySelector('.sticky-top'));
  }

  // Expand front page job list

  d.querySelectorAll('[data-toggle="expand"]').forEach(expander => {
    expander.addEventListener('click', (e) => {
      d.querySelector(expander.getAttribute('data-target')).classList.add('show');
      expander.innerHTML = expander.getAttribute('data-search-text');
      e.preventDefault();
    }, {once: true})
  });


  // Counter Animation

  counters = d.querySelectorAll('[data-count-to]');
  if (counters && typeof IntersectionObserver !== 'undefined') {

    // Setup observer
    var countIntersectionObserver = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        if (entry.intersectionRatio <= 0) return;
        entry.target.dCountStart();
      });
    });

    counters.forEach(countUp => {
        var dCountEnd    = countUp.getAttribute('data-count-to');
        if (!parseInt(dCountEnd, 10) > 0) {
          // skip if out of view or data-count-to value is zero or less,
          return;
        }
        countUp.textContent = "0";

        var dCountCurr   = 0,
          dCountRate     = 22, // 20 refresh per second
          dCountInc      = dCountEnd/dCountRate/2;

        countUp.dCountStart = function() {
          var dCoundInt = setInterval(function() {
            if (dCountCurr < dCountEnd) {
              dValue = Math.floor(dCountCurr);
              countUp.textContent = dValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              dCountCurr = dCountCurr + dCountInc;
            } else {
              countUp.textContent = dCountEnd.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              countIntersectionObserver.unobserve(countUp);
              clearInterval(dCoundInt);
            }
          }, 1000/dCountRate);
        }
      // Start observing
      countIntersectionObserver.observe(countUp);
    });
  }


  // Fade-in transition for lazy loading images

  d.querySelectorAll('img[loading="lazy"]').forEach(img => {
    if (img.complete == true) {
      img.classList.add('loaded');
    } else {
      img.addEventListener('load', (e) => {
        img.classList.add('loaded');
      }, {once: true});
    }
  });


  // Multi-file Upload

  var upload_count = 0;
  var no_fileupload = false;
  var multi_fileupload = d.querySelector('.multi-fileupload-group');

  if (multi_fileupload) {

    var ready = (callback) => {
      if (d.readyState != "loading") callback();
      else d.addEventListener("DOMContentLoaded", callback);
    }

    var parseHTML = function(str) {
      var tmp = d.implementation.createHTMLDocument();
      tmp.body.innerHTML = str;
      return tmp.body.children.item(0);
    };

    var getFilename = function(fullPath = '') {
      let startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
      let filename = fullPath.substring(startIndex);
      if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
        filename = filename.substring(1);
      }
      return filename;
    }

    var getAlert = function(classes, msg) {
      let html = parseHTML(`<div class="alert alert-dismissible alert-file-list fade show ${classes}" role="alert">${msg}<button type="button" class="close btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>`);
      return html;
    }

    // Add Fileupload
    var addUpload = function() {
      no_fileupload = false;
      upload_count++;

      if (upload_count > max_uploads) {
        no_fileupload = true;
        upload_count = max_uploads;
        return;
      }

      let fileinput = parseHTML(`<input class="form-control" type="file" name="${fname}" accept=".doc,.docx,.pdf">`);  

      // Trigger: Change - add file
      fileinput.addEventListener('change', (e) => {   
        let t = e.target;
        
        if (t.files[0].size > max_size) {
          // more than maximum size
          t.value = '';
          let alert = getAlert('alert-danger', msg['fileTooLarge']);
          
          setTimeout( () => { 
            a = new bootstrap.Alert(alert);
            a.close();
          }, alert_delay);
          multi_fileupload.append(alert);
          return;
        }
      
        fileinput.classList.add('invisible','d-none');

        // Add alert
        let filename = getFilename(t.value);
        let alert = getAlert('alert-light', filename);

        // Delete upload
        alert.addEventListener('closed.bs.alert', (e) => {
          upload_count--;
          fileinput.remove();
          if (no_fileupload == true) {
            addUpload();
          }
        });

        multi_fileupload.append(alert);

        addUpload();
      });
      multi_fileupload.prepend(fileinput);

    }

    // Run forest!
    ready(() => {
      addUpload();
    });

  }

  // Conversion Buttons
  var conversionPrompt = d.querySelector('#conversion-prompt');

  if (conversionPrompt) {
    var actionContainer = new bootstrap.Collapse(conversionPrompt, {
      toggle: false
    });
    var userTypeCookieName = '_vindex_usertyp';
    var userType = getCookie(userTypeCookieName, null);
    
    if (actionContainer && userType === null) {
      // Show container if cookie is missing
      actionContainer.show();
    } else {
      // Update cookie, expire 1 week after last visit
      setCookie(userTypeCookieName, userType, 1);
    }
    
    d.querySelectorAll('[data-action="convert"]').forEach(expander => {
      expander.addEventListener('click', (e) => {
        var userType = expander.getAttribute('data-action-value');
        setCookie('_vindex_usertyp',userType, 1);
    
        // Hide main container
        if (actionContainer) {
          actionContainer.hide();
        }
        e.preventDefault();
      }, {once: true})
    });
  }

  // Scroll to top on navigate to next tab
  // WP Job Manager - Job Application - LibreForm
  //
  // Target: id="wplf-job_application-top"
  // Triggers: .wplf-job_application-nav > button
  d.querySelectorAll('.wplf-form button.wplf-tabs__tabSwitcher, .wplf-form button[type="submit"]').forEach(el => {
    // console.log(el);
    el.addEventListener('click', (e) => {
      wplfScrollTo('#wplf-form-top', 500, -85);
    })
  });

});



